import { render, staticRenderFns } from "./ButtonChangeFolder.vue?vue&type=template&id=3e543fbb&"
import script from "./ButtonChangeFolder.vue?vue&type=script&lang=ts&"
export * from "./ButtonChangeFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports